import React from 'react';
import {
  FEEDBACK_TRIGGERS,
  FeedbackTrigger,
} from '../../../data/models/Feedback/Feedback';
import {isFeedbackTrigger} from '../feedbackForm';
import {feedbackText} from '../feedbackText';
import styles from './FeedbackTriggerField.module.css';

interface Props {
  value: FeedbackTrigger;
  disabled?: boolean;
  onChange: (trigger: FeedbackTrigger) => void;
}

const FeedbackTriggerField = ({value, disabled, onChange}: Props) => {
  return (
    <div className={styles.section}>
      <h2 className={styles.title}>{feedbackText.deliveryTitle}</h2>

      <div className={styles.field}>
        {/* <label className={styles.label} htmlFor="feedback-show-after">
          {feedbackText.showAfterLabel}
        </label> */}
        <select
          id="feedback-show-after"
          className={styles.select}
          value={value}
          disabled={disabled}
          onChange={ev => {
            const trigger = Number(ev.target.value);
            if (isFeedbackTrigger(trigger)) {
              onChange(trigger);
            }
          }}>
          {FEEDBACK_TRIGGERS.map(trigger => (
            <option key={trigger} value={trigger}>
              {feedbackText.showAfterOption(trigger)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FeedbackTriggerField;
